module.exports = __webpack_public_path__ + "static/media/icon-campaigns-white.29e5aaab.svg";